import React, { useEffect, useRef, useState } from 'react';
import { withTheme } from '../ThemeProvider';
import styles from './DoubleCarousel.module.less';

/**
 * @param {{
 *  images: Array<{ src: string; alt: string; link?: string}>;
 *  height: number;
 *  indexStart?: number;
 * }} param0
 */
function Images({ images, height, indexStart = 0 }) {
  const imageArray = [...images, ...images]?.map((image, index) => {
    return (
      <a
        className={`${styles.imageReference} ${!image.link && styles.inactiveLink}`}
        key={`image-array-${indexStart + index}`}
        href={image.link ?? '#'}
        style={{ height }}
        // eslint-disable-next-line react/jsx-no-target-blank
        target="_blank"
      >
        <img key={`image-array-item-${indexStart + index}`} src={image.src} alt={image.alt} className={styles.image} />
      </a>
    );
  });

  return <>{imageArray}</>;
}

/**
 * @param {{
 *   leftImages: Array<{ src: string; alt: string; link?: string}>;
 *   rightImages: Array<{ src: string; alt: string; link?: string}>;
 *   height: number;
 *   imagesPerPage?: number;
 *   secondsTotalDuration?: number;
 *   horizontalGap: number;
 * }} props
 */
const CustomDoubleCarousel = ({
  leftImages,
  rightImages,
  imagesPerPage = 4,
  height,
  secondsTotalDuration = 25,
  horizontalGap = 20,
  ...props
}) => {
  const container1 = useRef(null);
  const container2 = useRef(null);

  const [customHeight, setCustomHeight] = useState(0);

  useEffect(() => {
    const offset = Math.round(container1.current?.getBoundingClientRect().height) - height;
    setCustomHeight(offset);
  }, []);

  useEffect(() => {
    /**
     * @type {HTMLDivElement}
     */
    container1.current?.animate(
      [
        {
          transform: `translate(0%, -${(leftImages.length / imagesPerPage) * customHeight}px)`,
        },
        {
          transform: 'translate(0, 0)',
        },
      ],
      { duration: secondsTotalDuration * 1000, iterations: Infinity },
    );

    const secondOffset = (rightImages.length / imagesPerPage) * customHeight;
    // console.log('secondOffset', secondOffset);
    container2.current?.animate(
      [
        {
          transform: 'translate(0, 0)',
        },
        {
          transform: `translate(0%, -${secondOffset}px)`,
        },
      ],
      { duration: secondsTotalDuration * 1000, iterations: Infinity },
    );
  }, [customHeight]);

  return (
    <>
      <div className={styles.megaContainer} style={{ height }} {...props}>
        <div
          className={styles.container}
          ref={container1}
          style={{
            transform: `translate(0, -${customHeight}px)`,
            animationDuration: `${secondsTotalDuration}s`,
            marginRight: `${horizontalGap}px`,
          }}
        >
          <div className={styles.imageWrapper}>
            <Images images={leftImages} height={height / (imagesPerPage ?? leftImages.length)} />
          </div>
        </div>
        <div
          className={styles.container}
          ref={container2}
          style={{
            top: `0px`,
            animationDuration: `${secondsTotalDuration}s`,
          }}
        >
          <div className={styles.imageWrapper}>
            <Images images={rightImages} height={height / (imagesPerPage ?? leftImages.length)} indexStart={100} />
          </div>
        </div>
      </div>
    </>
  );
};

export default withTheme(React.memo(CustomDoubleCarousel));
